import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Head = () => {
  const [marqueeDirection, setMarqueeDirection] = useState('left');

  useEffect(() => {
    const interval = setInterval(() => {
      setMarqueeDirection(prev => prev === 'left' ? 'right' : 'left');
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  // Duplicate content for seamless scrolling
  const marqueeContent = (
    <>
      <span style={{ color: '#ffd700', padding: '0 20px', fontWeight: 'bold', fontSize: '1.1rem' }}>
        Why Smart People Are Choosing an Insurance Agent Career in India
      </span>
      <span style={{ color: 'white', padding: '0 10px' }}>||</span>
      <span style={{ color: 'white', padding: '0 20px' }}>
        Why Smart People Are Choosing an Insurance Agent Career in India
      </span>
      <span style={{ color: 'white', padding: '0 10px' }}>||</span>
    </>
  );

  return (
    <div className="top-header">
      {/* Marquee Section */}
      <div className="marquee-wrapper">
        <div className={`marquee-content ${marqueeDirection}`}>
          <div className="marquee-track">
            {marqueeContent}
          </div>
          <div className="marquee-track">
            {marqueeContent}
          </div>
        </div>
      </div>

      {/* Social Icons */}
      <div className="social-icons">
        <a href="https://www.facebook.com/agencybazaar.in/" target="_blank" rel="noopener noreferrer" >
          <i className="fab fa-facebook-f"></i>
        </a>
        <a href="https://www.instagram.com/agency_bazaar" target="_blank" rel="noopener noreferrer" >
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" >
          <i className="fab fa-twitter"></i>
        </a>
        <a href="https://www.youtube.com/@Financetalkwithsanjeev" target="_blank" rel="noopener noreferrer" >
          <i className="fab fa-youtube-play"></i>
        </a>
      </div>
    </div>
  );
};

export default Head;


